import { getAvailableI18nLocales } from "@/utils/getFilteredLocales";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import locale, { ILocale } from "locale-codes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const getFullName = (lang: ILocale) => {
  if (lang.location) {
    return `${lang.name} (${lang.location})`;
  } else {
    return `${lang.name} (${lang.tag})`;
  }
};

export const LanguageSelector = ({ size }: { size?: "small" | "medium" }) => {
  const { t, i18n } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState<ILocale | null>(locale.where("tag", i18n.language));

  const handleLanguageChange = async (e: any, newLang: ILocale | null) => {
    if (newLang) {
      setLang(newLang);
      await i18n.changeLanguage(newLang.tag);
    }
  };

  return (
    <>
      <FormControl
        variant="standard"
        fullWidth
        sx={{
          minWidth: 120,
          display: "flex",
          flexDirection: "column",
          gap: "1em"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Language Selector */}
        <Autocomplete
          id="locale-select"
          sx={{ minWidth: 300 }}
          value={lang}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          size={size}
          isOptionEqualToValue={(option, value) => option.tag === value.tag}
          getOptionLabel={(option) => getFullName(option)}
          getOptionKey={(option) => option.tag}
          options={getAvailableI18nLocales()}
          onChange={handleLanguageChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("label.language")}
              InputProps={{
                ...params.InputProps,
                endAdornment: null // Remove the clear button
              }}
            />
          )}
        />
      </FormControl>
    </>
  );
};
